import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import DeletedClientsTable from "./deleted";
import ClientsTable from "./all";
import { SecondaryTabPanel } from "src/shared/components/tabs/secondary-tabs-panel";
import { getTabA11yProps } from "src/shared/components/tabs/tab-props";

const ProductionTabs = () => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation("inventory");

  const labels = [t("all"), t("deleted")];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs value={value} onChange={handleChange}>
        {labels.map((label, index) => {
          return (
            <Tab
              disableRipple
              key={`${index}_${label}`}
              label={label}
              {...getTabA11yProps(index)}
            />
          );
        })}
      </Tabs>

      <Box mt={value === 0 ? { xs: "-20px", md: "-65px" } : {}}>
        <SecondaryTabPanel value={value} index={0}>
          <ClientsTable />
        </SecondaryTabPanel>
        <SecondaryTabPanel value={value} index={1}>
          <DeletedClientsTable />
        </SecondaryTabPanel>
      </Box>
    </Box>
  );
};

export default ProductionTabs;
